 <template> 
 <div>                  
    <b-card class="shadow mt-2">
    <b-form @submit="onSubmit" v-if="show">

        <h4> {{display.title}} </h4>
        <!-- <h5 style="color: red;"> Questionnaire obligatoire </h5> -->
        <hr>

        <b-form-group id="input-group-2" :label="display.firstname + ':'" label-for="input-2">
            <b-form-input
            id="input-2"
            v-model="form.firstname"
            required
            :placeholder="display.firstName"
            ></b-form-input>            
        </b-form-group>

         <b-form-group id="input-group-2b" :label="display.lastname + ':'" label-for="input-2b">
            <b-form-input
            id="input-2b"
            v-model="form.lastname"
            required
            :placeholder="display.lastName"
            ></b-form-input>            
        </b-form-group>

        <!-- <b-form-group id="input-group-4">
            <label for="datepicker">{{ $t('requestappt.q3') }}</label>
            <b-form-datepicker id="datepicker" v-model="form.date" class="mb-2" :placeholder="display.enterDate"></b-form-datepicker>
        </b-form-group>     -->

        <b-form-group id="input-group-3" :label="display.phone + ':'" label-for="input-3">
            <b-form-input
            id="input-3"
            v-model="form.phone"    
            required
            :placeholder="display.enterPhone"
            ></b-form-input>
        </b-form-group>

        <b-form-group
            id="input-group-email"
            :label="display.email+ ':'"
            label-for="input-email"
        >
            <b-form-input
            id="input-email"
            v-model="form.email"
            type="email"
            required
            :placeholder="display.enterEmail"
            ></b-form-input>
        </b-form-group>  

        <hr>


        <h4 class="font-weight-bold">{{display.q1}}</h4>
        <b-form-group>
            <b-form-checkbox-group id="checkboxes-5"  size="lg" stacked class="ml-5" :multiple="true" >
            <b-form-checkbox 
                v-for="(s,index) in display.q1a"
                v-model="form.q1a" 
                :key="index" 
                              
                :value="s" 
                class="my-2"        
                > {{s}}                                
            </b-form-checkbox>
            </b-form-checkbox-group> 
        </b-form-group>                           

        <b-form-group
            id="input-group-email"
            :label="display.q2+ ':'"
            label-for="input-email"
            class="mt-4"
        >
            <b-form-textarea
            id="q2a"
            v-model="form.q2a" 
            rows="3"
            
            ></b-form-textarea>
        </b-form-group>  

        <hr>  

        <h4 class="font-weight-bold">{{display.q3}}</h4>
            <b-form-textarea
            id="q3a"
            v-model="form.q3a" 
            rows="3"
            
            ></b-form-textarea>
        </b-form-group>  

        <!-- this is for the skincare routine products -->
        <hr>
        <h4 class="font-weight-bold">{{display.q4}}</h4>

        <label for="q4q1" class="mt-4">{{display.q4q1}}</label>
        <b-form-input id="q4q1" v-model="form.q4a1">  </b-form-input>

        <label for="q4q2" class="mt-4">{{display.q4q2}}</label>
        <b-form-input id="q4q2" v-model="form.q4a2"> </b-form-input>

        <label for="q4q3"  class="mt-4">{{display.q4q3}}</label>
        <b-form-input id="q4q3" v-model="form.q4a3"> </b-form-input>

        <label for="q4q4"  class="mt-4">{{display.q4q4}}</label>
        <b-form-input id="q4q4" v-model="form.q4a4"> </b-form-input>

        <label for="q4q5"  class="mt-4">{{display.q4q5}}</label>
        <b-form-input id="q4q5" v-model="form.q4a5"> </b-form-input>

        <label for="q4q6" class="mt-4">{{display.q4q6}}</label>
        <b-form-input id="q4q6" v-model="form.q4a6"> </b-form-input>

        <label for="q4q7" class="mt-4">{{display.q4q7}}</label>
        <b-form-input id="q4q7" v-model="form.q4a7"> </b-form-input>

        <label for="q4q8" class="mt-4">{{display.q4q8}}</label>
        <b-form-input id="q4q8" v-model="form.q4a8"> </b-form-input>

        <label for="q4q9" class="mt-4">{{display.q4q9}}</label>
        <b-form-input id="q4q9" v-model="form.q4a9"> </b-form-input>

        <label for="q4q10" class="mt-4">{{display.q4q10}}</label>
        <b-form-input id="q4q10" v-model="form.q4a10"> </b-form-input>


        <!-- end of products section  -->
        <hr>
        <b-form-group 
        id="input-group-9"
        :label="display.q5"
       >
            <b-form-textarea 
                v-model="form.q5a" 
                rows="3"     
                >                                
            </b-form-textarea>
        </b-form-group>   


        <hr>

        <h4>Merci de votre collaboration</h4>
               
        <br>
        <b-button type="submit"  squared variant="dark">{{$t('common.submit')}}</b-button>
        </b-form>
    </b-card>

    <b-card v-if="!show">
        <h4>Merci / Thank You</h4>
    </b-card>

</div>
</template>


<script>
const enData = {
  title: "Pre-Consultation Questionaire",
  firstname: "First Name",
  lastname: " Last Name",
  email: "Email",
  phone: "Phone Number",
  notes: "Notes For Us",
  times: ["morning", "afternoon", "evening"],
  enterNotes: "Type here...",
  enterDate: "No Date Selected",
  enterName: "Enter Name",
  enterEmail: "Enter Email",
  enterPhone: "Enter Phone Number",

  q1: "Préoccupations Visage",
  q1a: [
    "Rides et ridules",
    "Manque de tonus",
    "Rougeurs",
    "Imperfections cutanées (comédons, acné, cicatrices, etc..)",
    " Teint terne sans eclat",
    "Inconfort",
    "Peau sensible ou réactive",
    "Contour des yeux (poches, cernes, ridules)",
    "Effet bonne mine / protection solaire",
  ],
  q2: "Autres préoccupations? Spécifiez",
  q3: "Quelle est votre priorité face à votre peau? ",
  q4: "Décrivez votre routine de soins actuelle",
  q4q1: "Démaquillage des yeux:",
  q4q2: "Nettoyage du visage:",
  q4q3: "Sérum de jour/nuit:",
  q4q4: "Crème de jour/nuit:",
  q4q5: "Gommage:",
  q4q6: "Masque:",
  q4q7: "Protection solaire:",
  q4q8: "Soin des yeux:",
  q4q9: "Soin des lèvres:",
  q4q10: "Autres:",
  q5: "Aimeriez-vous partager d'autres informations avec votre esthéticienne? (Allergies, intolérances, etc?)",
};

const frData = {
  title: "QUESTIONNAIRE PRÉ-CONSULTATION",
  firstname: "Prénom",
  lastname: "Nom",
  email: "Courriel",
  phone: "Numéro de téléphone",
  notes: "Notes pour notre équipe",
  times: ["Matin", "Après-midi", "Soir"],
  enterNotes: "Écrivez ici...",
  enterDate: "Aucune date sélectionnée",
  enterName: "Entrez le nom",
  enterEmail: "Entrez votre e-mail",
  enterPhone: "Entrez le téléphone",
  q1: "Préoccupations Visage",
  q1a: [
    "Rides et ridules",
    "Manque de tonus",
    "Rougeurs",
    "Imperfections cutanées (comédons, acné, cicatrices, etc..)",
    " Teint terne sans eclat",
    "Inconfort",
    "Peau sensible ou réactive",
    "Contour des yeux (poches, cernes, ridules)",
    "Effet bonne mine / protection solaire",
  ],
  q2: "Autres préoccupations? Spécifiez",
  q3: "Quelle est votre priorité face à votre peau? ",
  q4: "Décrivez votre routine de soins actuelle",
  q4q1: "Démaquillage des yeux:",
  q4q2: "Nettoyage du visage:",
  q4q3: "Sérum de jour/nuit:",
  q4q4: "Crème de jour/nuit:",
  q4q5: "Gommage:",
  q4q6: "Masque:",
  q4q7: "Protection solaire:",
  q4q8: "Soin des yeux:",
  q4q9: "Soin des lèvres:",
  q4q10: "Autres:",
  q5: "Aimeriez-vous partager d'autres informations avec votre esthéticienne? (Allergies, intolérances, etc?)",
};

export default {
  data() {
    return {
      show: true,
      display: "",
      form: {
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        date: "",
        q1: "",
        q1a: [],
        q2: "",
        q2a: "",
        q3: "",
        q3a: "",
        q4: "",
        q4q1: "",
        q4a1: "",
        q4q2: "",
        q4a2: "",
        q4q3: "",
        q4a3: "",
        q4q4: "",
        q4a4: "",
        q4q5: "",
        q4a5: "",
        q4q6: "",
        q4a6: "",
        q4q7: "",
        q4a7: "",
        q4q8: "",
        q4a8: "",
        q4q9: "",
        q4a9: "",
        q4q10: "",
        q4a10: "",
        q5: "",
        q5a: "",
        q6a: "",
      },
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      // let data = (JSON.stringify(this.form))
      this.form.date = new Date(this.form.date);
      let data = Object.assign({}, this.form);
      console.log({ data: data });
      axios
        .post("https://beauteintegrale.ca/api/forms", { data: data })
        .then((resp) => {
          this.show = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getData() {
      if (this.$i18n.locale == "fr") {
        this.display = frData;
        this.form.q4q1 = this.display.q4q1;
        this.form.q4q2 = this.display.q4q2;
        this.form.q4q3 = this.display.q4q3;
        this.form.q4q4 = this.display.q4q4;
        this.form.q4q5 = this.display.q4q5;
        this.form.q4q6 = this.display.q4q6;
        this.form.q4q7 = this.display.q4q7;
        this.form.q4q8 = this.display.q4q8;
        this.form.q4q9 = this.display.q4q9;
        this.form.q4q10 = this.display.q4q10;
      } else this.display = enData;
      this.form.q4q1 = this.display.q4q1;
      this.form.q4q2 = this.display.q4q2;
      this.form.q4q3 = this.display.q4q3;
      this.form.q4q4 = this.display.q4q4;
      this.form.q4q5 = this.display.q4q5;
      this.form.q4q6 = this.display.q4q6;
      this.form.q4q7 = this.display.q4q7;
      this.form.q4q8 = this.display.q4q8;
      this.form.q4q9 = this.display.q4q9;
      this.form.q4q10 = this.display.q4q10;
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    answers() {
      console.log(this.form.questions);
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    locale: function (newLocale, oldLocale) {
      this.getData();
    },
  },
};
</script>
<style scoped>
h4 {
  font-weight: 700;
}
.b {
  font-weight: 700 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/FormIntake.vue